module.exports = __webpack_public_path__ + "static/media/depoimento-jozi.3db95846.jpeg";